import { IDLE, LOADING, SUCCESS } from '../../../../enums/states';
import { createReducer } from '../../utils/reducer';

import { OPENED_TRANSACTIONS_FETCH, OPENED_TRANSACTIONS_SUCCESS } from '../../../actions/dashboard/openedTransactions';

const initialState = {
  data: null,
  error: null,
  state: IDLE,
};

const handlers = {
  [OPENED_TRANSACTIONS_FETCH]: (state) => {
    return {
      ...state,
      state: LOADING,
    };
  },
  [OPENED_TRANSACTIONS_SUCCESS]: (state, action) => {
    return {
      ...state,
      state: SUCCESS,
      data: action.payload,
    };
  },
};

export default createReducer(initialState, handlers);
